<template>
  <div ref="sopBoard" style="position:relative" class="sopBoard">
    <div class="sop-expand" style="z-index: 1000" @click="handleUnfold">
      <span>{{ isUnfold ? $t('Sop.PackUp') : $t('Sop.Unfold') }}</span>
      <i v-if="!isUnfold" class="el-icon-arrow-down" />
      <i v-else class="el-icon-arrow-up" />
    </div>
    <div class="sop-tab" :class="{mask: showLayer}">
      <el-tabs v-model="activeName" :lazy="true" :class="{isUnfold : !isUnfold}" @tab-click="getNodeInfo">
        <el-tab-pane
          v-for="(item) in businessTypes"
          :key="item.name"
          :label="`${item.label} (${item.count?item.count: 0})`"
          :name="item.name"
          class="tab-pane-wrapper"
        >
          <template v-if="isUnfold&&rowDatas.length>0">
            <div class="sop-wrapper">
              <template v-for="(rowData, index) in rowDatas">
                <div :key="index" class="tab-guide-wrapper" :class="{flexend: !rowData.isOdd}">
                  <div
                    v-for="(item) in rowData.data"
                    :key="item.code"
                    class="tab-guide"
                    @click="jumpSopNodeDetail(item.code, '', item.name, '',item.disabled, item.subNodes)"
                  >
                    <el-popover
                      placement="bottom"
                      trigger="hover"
                      popper-class="sop-popover"
                      :visible-arrow="false"
                    >
                      <!-- 代码撤回 :style="{color: item.error && subItem.count !== '0' ? 'red': ''}" -->
                      <ul v-if="!item.disabled" class="sub-node">
                        <li
                          v-for="(subItem) in item.subNodes"
                          :key="subItem.subCode"
                          @click.stop="jumpSopNodeDetail(item.code, subItem.subCode, item.name, subItem.subName)"
                        ><span>{{ $store.getters.isZh ? subItem.subName : subItem.subEName }}：</span><span>{{ subItem.count }}</span></li>
                      </ul>
                      <el-button slot="reference">
                        <div class="tab-guide-column">
                          <div class="tab-guide-common">
                            <div class="tab-guide-row">
                              <div class="tab-guide-item" :class="{disabled: item.disabled}">
                                <svg-icon v-if="activeName === 'SI' || activeName === 'SE'" icon-class="sop-sea" class="svg-common" style="margin-right: 0px;" />
                                <svg-icon v-else-if="activeName === 'AI' || activeName === 'AE'" icon-class="sop-air" class="svg-common" style="margin-right: 0px;" />
                                <svg-icon v-else icon-class="sop-land" class="svg-common" style="margin-right: 0px;" />
                              </div>
                              <i v-if="item.error" class="el-icon-warning" />
                              <div class="tab-guide-arrow" />
                            </div>
                            <div v-if="item.name.length > 8" class="tab-guide-name" :title="item.copyName">{{ $store.getters.isZh ? item.name : item.eName }}</div>
                            <div v-else class="tab-guide-name">{{ $store.getters.isZh ? item.name : item.eName }}</div>
                          </div>
                        </div>
                      </el-button>
                    </el-popover>
                  </div>
                </div>
                <!-- v-show="rowDatas[`${index}+1`].data && rowDatas[`${index}+1`].data.length>0" -->
                <div :key="index+rowDatas.length" :class="[rowData.isOdd? 'tab-two': 'tab_three']" class="arrow">
                  <div class="tab-guide-arrow tab-guide-arrow_right" />
                </div>
              </template>
            </div>
            <div class="sop-wrapper-bar">
              <span style="margin: 0px 5px;color: #1F75D5;">{{ defaultName }}</span>
              <el-popover v-model="item.popVisible" placement="bottom-end">
                <el-button slot="reference" type="primary">
                  {{ $t('Message.SelectTemplate') }}
                  <i class="el-icon-arrow-down" style="color: #CCCCCC;" />
                </el-button>
                <el-table :data="templates" border :row-class-name="onRowClassName">
                  <el-table-column :label="$t('Template.TemplateName')" width="150">
                    <template slot-scope="{row}">
                      <div style="cursor: pointer;" @click="onTemplateClick(row)">{{ row.templateName }} ({{ row.nodeCount }})</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('CargoMsg.Cargo_DefaultOrNot')">
                    <template slot-scope="{row}">
                      <el-checkbox :value="row.homepageDisplayOnUser" @input="val=>onCheckInput(item,row,val)" />
                    </template>
                  </el-table-column>
                </el-table>
              </el-popover>
            </div>
          </template>
          <div style="clear:both;" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    businessTypes: {
      type: Array,
      default: function() {
        return []
      }
    },
    sopNodeData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    sopNodeQuery: {
      type: Object,
      default: function() {
        return {}
      }
    },
    sopClientHeight: {
      type: String,
      default: ''
    },
    sopLayerStyle: {
      type: Object,
      default: function() {
        return {}
      }
    },
    status: {
      type: Boolean,
      default: true
    },
    showLayer: {
      type: Boolean,
      default: false
    },
    lob: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeName: this.lob,
      data: [],
      dialogVisible: false,
      rowData1: [],
      rowData2: [],
      rowData3: [],
      rowData4: [],
      rowData5: [],
      rowData6: [],
      currentCode: '',
      isUnfold: true,
      timer: null,
      isEnter: false,
      cacheActiveName: [],
      isCloseSopLayer: 0,
      defaultName: '',
      templates: '',
      rowDatas: [],
      templateKey: ''
    }
  },
  computed: {
    ...mapGetters([
      'userId'
    ])
  },
  watch: {
    activeName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.__resizeHandler()
      }
    },
    lob(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.activeName = newVal
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.__resizeHandler)
  },
  methods: {
    getNodeInfo() {
      const activeName = this.activeName
      this.$emit('getActiveName', activeName)
    },
    __resizeHandler() {
      const resdata = this.sopNodeData[this.activeName]
      const clientWidth = document.body.clientWidth
      this.rowDatas = []
      // 182
      if (resdata) {
        if (clientWidth >= 2560) {
          this.handleRowData(resdata, 19)
        } else if (clientWidth >= 1920) {
          this.handleRowData(resdata, 13)
        } else if (clientWidth >= 1440) { // 10
          this.handleRowData(resdata, 10)
        } else if (clientWidth >= 1280) {
          this.handleRowData(resdata, 8)
        } else { this.handleRowData(resdata, 7) }
      }
    },
    handleRowData({ templates, sopNodeJobStatistics }, len) {
      this.templates = templates
      let defaultTemplate = null
      for (const item of templates) {
        if (item.selected) {
          defaultTemplate = item
          break
        } else if (item.homepageDisplayOnUser) {
          defaultTemplate = item
        }
      }
      this.defaultName = defaultTemplate ? defaultTemplate.templateName : ''
      this.templateKey = defaultTemplate ? defaultTemplate.uuid || '' : ''
      const dataLen = sopNodeJobStatistics.length
      const row = Math.ceil(dataLen / len)
      let rowData = {}
      for (let i = 1; i <= row; i++) {
        if (i % 2 === 0) {
          rowData = { data: sopNodeJobStatistics.slice((i - 1) * len, i * len).reverse(), isOdd: false }
        } else {
          rowData = { data: sopNodeJobStatistics.slice((i - 1) * len, i * len), isOdd: true }
        }
        this.rowDatas.push(rowData)
      }
    },
    showBoardDialog() {
      this.dialogVisible = true
    },
    handleUnfold() {
      this.isUnfold = !this.isUnfold
    },
    // 打开对应的模块，查出相应的业务
    jumpSopNodeDetail(sopCode, sopSubCode = '', name, subName = '', disabled, subNodes = []) {
      if (disabled) return
      const newSubNodes = subNodes.map(item => {
        item.name = item.subName
        item.code = item.subCode
        delete item.subName
        delete item.subCode
        delete item.count
        return item
      })
      const data = { sopCode, sopSubCode, name, subName, newSubNodes }
      this.$emit('jumpSopNodeDetail', data)
    },
    onTemplateClick(row) {
      this.templates = Array.from(this.templates, p => {
        p.selected = p.uuid === row.uuid
        return p
      })
      this.templateKey = row.uuid
      this.$emit('templateClick', row.uuid)
    },
    onCheckInput(businessType, row, newVal) {
      if (newVal) {
        let oldTemplateKey = ''
        for (const template of this.templates) {
          if (template.homepageDisplayOnUser) {
            oldTemplateKey = template.uuid
            break
          }
        }
        this.$emit('templateChange', oldTemplateKey, row.uuid)
      }
      businessType.popVisible = false
    },
    onRowClassName({ row }) {
      if (row.selected) {
        return 'template-row template-selected'
      }
      return 'template-row'
    }
  }
}
</script>
<style lang="scss">
.layer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  p {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
.sop-expand {
  position: absolute;
  right: 0px;
  color: #1F75D5;
  top: 0px;
  & > i {
    font-size: 13px;
    margin-left: 7px;
    cursor: pointer;
  }
}
.isUnfold {
  .el-tabs__content{
    height: 0px;
  }
}
.sop-tab {
  .sop-wrapper {
    float: left;
  }
  .sop-wrapper-bar {
    float: right;
  }
  .el-tabs--top {
    .el-tabs__item {
      padding: 0 25px;
    }
  }
  .el-tabs__content{
    overflow: auto;
  }
  .el-tab-pane1{
    // width: 1694px;
  }
 @media screen and (min-width: 1024px){
     .tab-guide-wrapper {
        max-width: 800px
     }
      .tab-guide-arrow_right {
       left: 750px;
     }
}
 @media screen and (max-width: 1024px){
     .tab-guide-wrapper {
        max-width: 800px
     }
      .tab-guide-arrow_right {
       left: 750px;
     }
}
 @media screen and (min-width: 1280px) {
     .tab-guide-wrapper {
        max-width: 1048px
     }
    .tab-guide-arrow_right {
       left: 874px;
     }
}
 @media screen and (min-width: 1440px) {
     .tab-guide-wrapper {
        max-width: 1172px
     }
      .tab-guide-arrow_right {
       left: 1120px;
     }
}
//  @media screen and (min-width: 1760px) {
//      .tab-guide-wrapper {
//         max-width: 1504px
//      }
//     .tab-guide-arrow_right {
//        left: 1440px;
//      }
// }
//
 @media screen and (min-width: 1920px) {
     .tab-guide-wrapper {
        max-width: 1668px
     }
      .tab-guide-arrow_right {
       left:1495px;
     }
}
 @media screen and (min-width: 2560px) {
     .tab-guide-wrapper {
        max-width: 2288px
     }
    .tab-guide-arrow_right {
       left: 2238px;
     }
}
  .tab-guide-wrapper {
    display: flex;
		flex-wrap: wrap;
    margin-bottom: 14px;
    .tab-guide {
      display: flex;
      // position: relative;
      align-items: center;
			// margin-right: 126px;
      width: 124px;
      .el-popover__reference-wrapper {
        .el-button,.el-button:hover {
          background: unset;
          border: none;
        }
        .el-button--mini {
          padding:0px;
        }
      }
      .tab-guide-column {
        display: flex;
        flex-direction: column;
        .tab-guide-common {
          width:56px;
          flex-direction: column;
          display: flex;
          align-items: center
        }
        .tab-guide-row {
          display: flex;
          align-items: center;
          position: relative;
          .el-icon-warning {
            position: absolute;
            top: 0;
            color: #F96A6C;
            left: 38px;
            font-size: 20px;
          }
          .tab-guide-item {
            width: 56px;
            height: 56px;
            background: #deeaf9;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            .svg-common {
              width: 32px;
              height: 28px;
              margin-right: 0px;
              color: #1F75D5;
            }
          }
          .disabled {
            background: rgb(228, 230, 235);
            .svg-common {
              color: #999;
            }
          }
          .tab-guide-arrow {
            position: absolute;
            width: 46px;
            height: 0;
            border-bottom: 2px dashed #1f75d5;
            left: 67px;
          }
        }
        .tab-guide-name {
          margin-top: 14px;
          // text-align: center;
          position: relative;
          // left: 50%;
          width:56px;
          // transform: translateX(-50%);
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: break-spaces;
          padding-bottom: 1px;
        }
      }
    }
    .tab-guide:last-child{
      // margin-right: 0;
      width: 56px;
    }

  }
  .tab_threeRowData{
    .tab-guide{
      .tab-guide-column{
        .tab-guide-row{
          .tab-guide-arrow{
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .tab-guide-wrapper .tab-guide:last-child .tab-guide-arrow{
    display: none;
  }
  // .tab-guide-wrapper {
  //   .tab-guide:first-child {
  //     .tab-guide-name {
  //       transform-origin: left;
  //       left: 100%;
  //       text-align: left;
  //     }
  //   }
  // }
  .tab-two{
    height: 46px;
    position: relative;
    top: 12px;
    .tab-guide-arrow {
            position: absolute;
            width: 46px;
            height: 0;
            border-bottom: 2px dashed #1f75d5;
            //right: 95px;
            top: 0px;
            transform: rotate(90deg);
          }
  }
  .tab_three{
    height: 46px;
    position: relative;
    top: 12px;
    .tab-guide-arrow {
            position: absolute;
            width: 46px;
            height: 0;
            border-bottom: 2px dashed #1f75d5;
            left: 5px;
            transform: rotate(90deg);
          }
  }
}
.mask {
  .el-tabs__content{
    height: 106px;
  }
}
  .pop-content {
    font-size: 12px;
    color: #333;
    line-height: 28px;
  }
  // .el-tab-pane {
  //   height: 260px;
  // }
  .sub-node {
    color :#333;
    border-radius: 4px;
    z-index: 99;
    list-style: none;
    padding: 0px 10px;
    box-sizing: border-box;
    width: max-content;
    li {
      margin-bottom: 11px;
      overflow: hidden;
      cursor: pointer;
       display: flex;
      &>span:first-child{
        // float: left;
        text-align: right;
        flex:1;
      }
      &>span:last-child {
        // float: right;
        width: 50px;
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
.tab-pane-wrapper {
  position: relative;
  min-width: 100%;
  width: max-content;
}
.flexend {
  justify-content: flex-end;
  margin-right: 0px;
  // position: absolute;
  // right: 0px;
}
.el-popover.sop-popover {
  min-width: unset;
  padding: 0px;
}
.arrow:last-child {
  display:none;
}
.el-table .el-table__body tr.template-row {
  &.template-selected > td.el-table__cell {
    background-color: #1f75d5;
    color: #fff;
  }
  &:hover > td.el-table__cell, &.template-selected:hover > td.el-table__cell {
    background-color: #e9f1fb;
    color: #4c91dd;
  }
}
</style>
